////////LIBRARY/////////
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import _, { map, cloneDeep, reduce, isUndefined, isEmpty, isString, find, debounce, isEqual, forEach, findIndex, isNull } from 'lodash'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'
///////COMPONENTS///////
import Button from '../../components/Ui/Buttons'
import UseWindowResize from '../../hooks/UseWindowResize'
import {
	exportDatasActionCreators,
	globalLoadingActionCreators,
	columnsActionCreators,
	initKioskCreationImplantationActionCreators,
	tableActionCreators,
} from '../../store/actions'
import {
	ActionWrapper,
	ActionWrapperElem,
	OptionCustom,
	TableActionsWrapper,
	SelectInputCustom,
	SelectInputWrapper,
	TableWrapper,
	//TableContent,
} from '../../theme/GlobalCss'
import theme from '../../theme/theme'
import Tooltip from '../Tooltip/Tooltip'
import TooltipHelp from '../TooltipHelp'
import ImgButton from '../Ui/ImgButton'
import TableBody from './components/TableBody'
import TableHeader from './components/TableHeader'
import UseColumnsManager from './hooks/UseColumnsManager'
import UseTableSort from './hooks/UseTableSort'
/////////ASSETS/////////
import ArrowDownGrey from '../../assets/icones/global/arrow-down-big-grey.svg'
import ArrowDown from '../../assets/icones/global/arrow-down-big.svg'
import ArrowLeftGrey from '../../assets/icones/global/arrow-left-grey.svg'
//Arrow Scroll Bar
import ArrowLeft from '../../assets/icones/global/arrow-left.svg'
import ArrowRightGrey from '../../assets/icones/global/arrow-right-grey.svg'
import ArrowRight from '../../assets/icones/global/arrow-right.svg'
import ArrowUpGrey from '../../assets/icones/global/arrow-up-big-grey.svg'
import ArrowUp from '../../assets/icones/global/arrow-up-big.svg'
import Validation from '../../assets/icones/global/check.svg'
import { default as Cancel } from '../../assets/icones/global/close-white.svg'
import Edit from '../../assets/icones/global/edit-white.svg'
import Reset from '../../assets/icones/global/reset-white.svg'
import Export from '../../assets/icones/table/export-datas.svg'
import ExportMerchantTicket from '../../assets/icones/table/export-merchant-ticket.svg'
import { cps } from 'redux-saga/effects'

/////////STYLED/////////
const TableActionsAndTitle = styled.div`
	display: ${(props) => (props.shown ? 'none' : 'grid')};
	grid-template-columns: repeat(2, minmax(min-content, max-content));
	grid-auto-flow: column;
	grid-column-gap: 10px;
	grid-template-rows: max-content;
	grid-auto-rows: 32px;
	margin-bottom: 14px;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`
const TableContent = styled.table`
	border-spacing: 0;
	box-sizing: border-box;
	min-width: 100%;
	width: max-content;
	position: relative;
	z-index: 1;
`
const TableReverse = styled.form`
	overflow-x: hidden;
	position: relative;
	height: ${(props) => (props.autosize ? 'auto' : `${props.sizeheight - 345}px`)};
	&::-webkit-scrollbar {
		width: ${(props) => (props.tableVirtualizeHeight > props.tableOverflowHeight ? '15px' : '0px')};
		background-color: ${(props) => (props.tableVirtualizeHeight > props.tableOverflowHeight ? 'rgba(0,0,0,.15)' : null)};
		height: ${(props) => (props.tableVirtualizeHeight > props.tableOverflowHeight ? '50px' : '0px')};
	}
	&::-webkit-scrollbar-thumb {
		background: #4d4f5c;
	}
	&::-webkit-scrollbar-thumb:active {
		background: rgba(77, 79, 92, 0.7);
	}
	&::-webkit-scrollbar-button:vertical:decrement:single-button {
		background: no-repeat url(${ArrowUp}) center;
		height: 15px;
	}
	&::-webkit-scrollbar-button:vertical:increment:single-button {
		background: no-repeat url(${ArrowDown}) center;
		height: 15px;
	}
	&::-webkit-scrollbar-button:vertical:decrement:single-button:active {
		background: no-repeat url(${ArrowUpGrey}) center;
		height: 15px;
	}
	&::-webkit-scrollbar-button:vertical:increment:single-button:active {
		background: no-repeat url(${ArrowDownGrey}) center;
		height: 15px;
	}
	/* scrollbar styling standard version */
	& {
		scrollbar-color: #4d4f5c #e5e5e5;
		scrollbar-width: thin;
	}
`
const SplitX = styled.div`
	height: 32px;
	border-left: 1px solid ${(props) => props.theme.colors.dropdownDefault};
	width: 1px;
	box-sizing: border-box;
	margin: 8px 17px;
`
const ScrollTopWrapper = styled.div`
	width: ${(props) => props.width};
	overflow-x: ${(props) => (props.isScrollable ? 'scroll' : 'hidden')};
	&::-webkit-scrollbar {
		width: 50px;
		background-color: rgba(0, 0, 0, 0.15);
		height: 15px;
	}
	&::-webkit-scrollbar-thumb {
		background: #4d4f5c;
		height: 100%;
	}
	&::-webkit-scrollbar-thumb:active {
		background: rgba(77, 79, 92, 0.7);
		height: 100%;
	}
	&::-webkit-scrollbar-button:horizontal:decrement:single-button {
		background: no-repeat center url(${ArrowLeft});
		height: 9px;
		width: 15px;
		margin-bottom: 1px;
	}
	&::-webkit-scrollbar-button:horizontal:increment:single-button {
		background: no-repeat center url(${ArrowRight});
		height: 9px;
		width: 15px;
		padding-bottom: 10%;
	}
	&::-webkit-scrollbar-button:horizontal:decrement:single-button:active {
		background: no-repeat center url(${ArrowLeftGrey});
		height: 9px;
		width: 15px;
		margin-bottom: 1px;
	}
	&::-webkit-scrollbar-button:horizontal:increment:single-button:active {
		background: no-repeat center url(${ArrowRightGrey});
		height: 9px;
		width: 15px;
		padding-bottom: 10%;
	}
	/* scrollbar styling standard version */
	& {
		scrollbar-color: #4d4f5c #e5e5e5;
		scrollbar-width: thin;
	}
`
const ScrollTop = styled.div`
	width: ${(props) => props.width};
	height: 1px;
`
const ExportWrapper = styled(ActionWrapperElem)`
	width: 32px;
	height: 32px;
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	align-items: center;
	justify-content: center;
	cursor: pointer;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
const ExportButton = styled.img`
	width: 24px;
	height: 24px;
`
// Wrapper used to anchor the export choice menu under the export button
const ExportContainer = styled.div`
	display: flex;
	position: relative;
`
const ExportMenu = styled.div`
	position: absolute;
	top: 100%;
	right: 0;
	margin-top: 4px;
	width: 290px;
	background-color: ${(props) => props.theme.colors.white};
	border: 1px solid ${(props) => props.theme.colors.dropdownDefault};
	border-radius: 4px;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
	overflow: hidden;
	z-index: 10;
`
const ExportMenuItem = styled.button`
	display: block;
	width: 100%;
	padding: 10px 14px;
	border: none;
	background-color: transparent;
	color: ${(props) => props.theme.colors.table.body.text};
	font-size: ${(props) => props.theme.font.fs};
	font-family: inherit;
	text-align: left;
	cursor: pointer;
	:hover {
		background-color: ${(props) => props.theme.colors.table.header.main};
	}
	& + & {
		border-top: 1px solid ${(props) => props.theme.colors.dropdownDefault};
	}
`
const ExportMenuItemLabel = styled.span`
	display: block;
	${ExportMenuItem}:hover & {
		color: ${(props) => props.theme.colors.primary};
	}
`
// Hint line explaining which mode fits the current volume of data
const ExportMenuItemHint = styled.span`
	display: block;
	margin-top: 3px;
	font-size: 11px;
	line-height: 14px;
	color: ${(props) => (props.warning ? props.theme.colors.error : props.theme.colors.eraser)};
`
const TableVirtualizeWrapper = styled.div`
	position: relative;
`
const WrapperFormButton = styled.div`
	position: absolute;
	top: ${(props) => (props.isEditingTrigger ? '2px' : '61px')};
	right: ${(props) => (props.positionRight ? '225px' : '-6px')};
	display: flex;
	flex-direction: row-reverse;
`
/////////STYLED/////////
/**
 *
 * @param {array} inputColumns
 * @param {array} inputData
 * @param {object} inputConfig
 * @return {*}
 * @constructor
 */
const Table = ({ inputColumns, inputData, inputConfig, isLoading = {}, currentPaging, tableReferential, actionSort }) => {
	const tableOverflowRef = useRef() // Ref storing form tag
	const tableVirtualizeRef = useRef() // RPef storing wrapper of table
	const tableContentRef = useRef() // Ref storing wrapper of header and rows
	const bodyWrapperRef = useRef() // Equivalent to size of rows
	const scrollBarTopRef = useRef() // Ref storing horizontal scrollbar
	const previousInputDataRef = useRef(inputData) // Used to tell a new data set from a simple window extension
	const skipToggleAllSyncRef = useRef(false) // Rows are already synced when we reset the global chevron ourselves

	const { user, translations, cols, isEditingTrigger } = useSelector(
		(state) => ({
			user: state.user.identity.rolePrivileges.privileges,
			translations: state.languages.translations,
			cols: state.columns.col,
			isEditingTrigger: state.columns.isEditingTrigger,
		}),
		shallowEqual
	)

	const { register, handleSubmit, clearErrors, getValues, setValue, reset, errors, formState, watch } = useForm({
		mode: 'onChange',
	})
	const { isDirty, touched, isValid, isSubmitting } = formState
	const selectAction = useRef()
	const selectTable = useRef()
	const selectWrapperFormButton = useRef()

	const [editing, setEditing] = useState(false)
	const [selectedData, setSelectedData] = useState([])
	const [nameDir, setNameDir] = useState(true)
	const [sortableColumn, setSortableColumn] = useState()

	// For columns display saving
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	const [columns, handleColumnsFilter] = UseColumnsManager(inputColumns, actionsTable.setSavedTableColumnsDisplay, tableReferential)
	const [colsTable, setColsTable] = useState()
	const [dimensions] = UseWindowResize()

	const actionsExportDatas = bindActionCreators(exportDatasActionCreators, useDispatch())
	const actionsGlobalLoading = bindActionCreators(globalLoadingActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsKioskImplantation = bindActionCreators(initKioskCreationImplantationActionCreators, useDispatch())

	// disabled button mass edit if no line is selected
	const [isMassEdit, setIsMassEdit] = useState(false)
	const [isSingleEdit, setSingleEdit] = useState(false)

	// Boolean to hide table loader
	const [isScrolling, setIsScrolling] = useState(false)
	// Default line height (px)

	const [selectTarget, setSelectTarget] = useState(false) // when is true we change placeholder color of select element
	const [tableData, trigger, setTrigger, setTableData, setForceUnsort] = UseTableSort(inputColumns)

	const [storedValues, setStoredValues] = useState() // Used for storing input values
	const [storedChecks, setStoredChecks] = useState([]) // Used for storing checked boxes
	// Flag used when reset form button is clicked. It prevents to store values when it is not needed
	const [resetCalled, setResetCalled] = useState(false)

	const [currentY, setCurrentY] = useState(0) // Used to store position of vertical scroll
	const [bottomReached, setBottomReached] = useState(false) // Used to know if bottom of vertical scroll is reached

	// Those state could be replace by page configuration on load ?
	const [visibleRows, setVisibleRows] = useState(20) // Number of visible rows
	const [padVisibleRows, setPadVisibleRows] = useState(10) // Number of rows to be added after scroll

	const [usingSkeleton, setUsingSkeleton] = useState(false) // Used to know if we are asking skeleton rows (data is "loading")
	const [nextVisibleRowsCount, setNextVisibleRowsCount] = useState(0) // Store next visible rows, sum of visible rows and skeleton rows

	const [scrollBarRender, setScrollBarRender] = useState() // Handling of horiziontal scroll bar
	const [widthTable, setWidthTable] = useState(0)
	const [heightTable, setHeightTable] = useState(30)
	const [scrollBarWidth, setScrollBarWidth] = useState(0) // Used to calculate size of horziontal scroll bar wrapper

	const [currentPagingSave, setCurrentPagingSave] = useState()

	//to prevent flush storedChecks array when scrolling
	const [isScrollingContext, setIsScrollingContext] = useState()

	// to test if export button need to be display
	const [isExportVisible, setIsExportVisible] = useState(false)
	// Export choice menu (direct download / export by email). Only displayed when the page provides a mail export modal
	const [isExportMenuOpen, setIsExportMenuOpen] = useState(false)
	const exportMenuRef = useRef()
	const hasExportChoice = typeof inputConfig?.export?.fnOpenExportModal === 'function'
	// Above the limit given by the page, the direct download exceeds the timeout of the front <-> back
	// communication : we warn the user so he uses the export by email instead
	const exportRecordsCount = inputConfig?.export?.recordsCount
	const exportRecordsCountLimit = inputConfig?.export?.recordsCountLimit
	const isExportVolumeTooHigh =
		!isUndefined(exportRecordsCount) && !isUndefined(exportRecordsCountLimit) && exportRecordsCount > exportRecordsCountLimit
	// State of toggling all nested lines button
	const [toggleAllNestedHandler, setToggleAllNestedHandler] = useState(
		inputConfig.nestedValues?.defaultVisible ? inputConfig.nestedValues?.defaultVisible : false
	)

	// When using column sort
	const handleSortTableHeader = (sortableId, headerName) => {
		const flagByItem = !isUndefined(inputConfig.export) ? inputConfig.export.privilege : ''
		if (!isUndefined(actionSort) && !isUndefined(sortableId)) {
			if (currentPaging == undefined) return
			let dir = cloneDeep(nameDir)
			if (sortableId != sortableColumn) dir = true
			let currentPagingCp = cloneDeep(currentPaging)
			let newCurrentPaging = {
				sort: sortableId,
				nameDir: dir ? 'asc' : 'desc',
				page: currentPagingCp.page,
				size: currentPagingCp.size,
				action: flagByItem === 'extranet__admin__pricesByItem_export' ? 'byItem' : '', // maybe we can refact this arg is miss when we sort column on price by article page
			}
			actionSort(inputConfig?.export?.bd, newCurrentPaging, 'sortable')
			setCurrentPagingSave(newCurrentPaging)
			actionsColumns.setCurrentColumn(sortableId)
			actionsColumns.setCurrentDir(dir ? 'asc' : 'desc')
			setNameDir(!dir)
			setSortableColumn(sortableId)
			actionsTable.setSavedPaggingConfig(newCurrentPaging)
		} else {
			setTrigger({
				data: headerName,
				trigger: trigger + 1,
			})
		}

		if (isScrollingContext) {
			setIsScrollingContext()
		}
	}
	// Old method, used to know if we can click edit button, but is it conflicting with windowing.
	// In windowing, DOM contains only visible rows.
	// If we have checked box and we are scrolling till is isn't visible, button is disabling.
	/*useEffect( () => {
		for( const p in getValues()) {
			if(getValues()[p] !== false) {

				setSingleEdit(true)
				break
			} else {
				setSingleEdit(false)
			}
	
		}
	}, [getValues()])*/

	// On click in checkbox, storing data
	const handleCheckValues = (value) => {
		let arr = cloneDeep(storedChecks)
		const f = findIndex(storedChecks, (o) => {
			return isEqual(value, o)
		})
		if (f > -1 && !isEmpty(arr)) {
			arr.splice(f, 1)
		} else {
			arr.push(value)
		}

		setSingleEdit(!isEmpty(arr))
		setStoredChecks(arr)
	}
	const createSelectedDataList = () => {
		// Old method. getValues() will only contains lines in DOM, not in all data available (but not rendered)
		// Therefore it is conflicting with windowing system.
		//const data = getValues()
		const data = storedChecks
		return reduce(
			data,
			(result, value) => {
				if (value) {
					const parsedValue = JSON.parse(value)
					if (parsedValue.standardLine || isUndefined(parsedValue.standardLine)) {
						result.push(JSON.parse(value))
					}
				}
				return result
			},
			[]
		)
	}

	const handleMassEdit = () => {
		setSelectedData(createSelectedDataList())
		// Prevent editing if no row is selected
		if (!editing && isEmpty(createSelectedDataList())) return
		setEditing((prevState) => !prevState)
		// to display button on TableTitle and hide un checked columns we need to pass a state with store
		actionsColumns.setIsEditingTrigger()
	}

	const handleGetSelected = (target) => {
		const scope = isString(target) ? target : ''
		const query = target
		inputConfig.actions.edit.getDataSelected(createSelectedDataList(), scope, query)
	}

	const handleOpenModalSearch = () => {
		inputConfig.actions.edit.openModalSelectedSearch()
	}

	const handleOnSubmit = (data) => {
		const dataCP = cloneDeep(data)
		inputConfig.actions.edit.validate(dataCP, selectedData)
		setEditing(false)
		actionsColumns.setIsEditingNotTrigger()
	}
	const handleResetForm = () => {
		reset()
		//fn()
		setResetCalled(true)
	}

	const handleCloseForm = (fn) => {
		setStoredChecks([])
		setEditing((prevState) => !prevState)
		reset()
		!isUndefined(fn) && fn()
		actionsColumns.setIsEditingNotTrigger()
		actionsColumns.setFormButtonWidth(0)
	}

	// When using horizontal scrollbar
	const handleTableScrollTop = (e) => {
		tableOverflowRef.current.scrollLeft = e.target.scrollLeft
	}

	// When scrolling (onWheel)
	// We will determine position of vertical scroll, and also allows to use horizontal scroll
	const handleScroll = (evt) => {
		setIsScrollingContext(true)
		// Calculating maximum vertical scroll available
		let maxY
		// Browser differences, some infos aren't available
		if (isUndefined(tableOverflowRef.current.scrollMaxY)) {
			maxY = Math.round(tableOverflowRef.current.scrollHeight - tableOverflowRef.current.clientHeight)
		} else {
			maxY = Math.round(tableOverflowRef.current.scrollMaxY)
		}
		// Storing position of vertical scroll
		setCurrentY(tableOverflowRef.current.scrollTop)

		// Determine if bottom is reached or not, at anytime
		if (tableOverflowRef.current.scrollTop === maxY && currentY !== maxY) {
			setBottomReached(true)
		} else if (tableOverflowRef.current.scrollTop !== maxY) {
			setBottomReached(false)
		}

		// Check if user is pressing shift key
		const shiftKey = evt.nativeEvent.shiftKey
		if (!isScrolling) {
			setIsScrolling(true)
		}
		if (!shiftKey) return

		// Check direction of "wheeling" : left of right, allowed by pressed shift key
		if (Math.sign(evt.nativeEvent.deltaY) > 0) {
			scrollBarTopRef.current.scrollLeft = tableOverflowRef.current.scrollLeft + 50
		} else {
			scrollBarTopRef.current.scrollLeft = tableOverflowRef.current.scrollLeft - 50
		}
	}

	// Debounced function to close scroll listening
	const delayedScrollHide = useCallback(
		debounce(() => {
			setIsScrolling(false)
		}, 100),
		[isScrolling]
	)

	// action to make export
	// test if which config we use to export
	const handleExportData = (typeExport = null) => {
		if (!isNull(typeExport)) {
			actionsExportDatas.postExportDatas(inputConfig.exportMerchantTicket.bd, inputConfig.exportMerchantTicket.url)
		} else {
			actionsExportDatas.postExportDatas(inputConfig.export.bd, inputConfig.export.url)
		}
	}

	// Click on the export button : open the choice menu if the page allows both modes, else keep the direct download
	const handleExportClick = () => {
		if (hasExportChoice) {
			setIsExportMenuOpen((prevState) => !prevState)
			return
		}
		handleExportData()
	}

	// Choice made in the export menu : 'email' opens the recipient modal, anything else downloads the file
	const handleExportChoice = (mode) => {
		setIsExportMenuOpen(false)
		if (mode === 'email') {
			inputConfig.export.fnOpenExportModal()
		} else {
			handleExportData()
		}
	}

	// when we select an action to open a modal, we force the capacity to select the same modal when we close it
	const handleChoiceTarget = () => {
		setSelectTarget(true)
	}

	const handleResetSelect = (_e, _reset = false) => {
		if (reset) {
			setSelectTarget(false)

			selectAction.current.value = ''
			return null
		}
		handleChoiceTarget()
	}

	const formHeightHandler = () => {
		let h = 0
		if (!isUndefined(inputConfig?.customHeightFilters)) {
			h += inputConfig?.customHeightFilters
		}
		if (inputConfig?.usingRafters) {
			h += 60
		}
		return dimensions.height - h - 20
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////
	useEffect(() => {
		actionsColumns.setFormButtonWidth(selectWrapperFormButton.current.clientWidth)
	}, [selectWrapperFormButton.current?.clientWidth])

	// If base data is changing (paging or edition)
	useEffect(() => {
		// Nested rows state (toggleNested) is stored in the data itself, and tableData is a clone of inputData.
		// Extending the virtualization window (visibleRows) must keep the opened rows,
		// while a new data set (new back call) starts back from the configured default.
		const isNewDataSet = previousInputDataRef.current !== inputData
		previousInputDataRef.current = inputData
		const defaultToggleNested = inputConfig.nestedValues?.defaultVisible ? inputConfig.nestedValues.defaultVisible : false

		const expandedById = {}
		if (!isNewDataSet) {
			map(tableData, (elem) => {
				expandedById[elem.id] = elem.toggleNested
			})
		}

		map(inputData, (elem, k) => {
			if (k >= visibleRows) {
				elem.rowTableVisible = false
				elem.rowTableSkeleton = false
			} else {
				elem.rowTableVisible = true
				elem.rowTableSkeleton = false
			}
			if (inputConfig.nestedValues) {
				elem.toggleNested = !isUndefined(expandedById[elem.id]) ? expandedById[elem.id] : defaultToggleNested
			}
		})
		setCurrentY(0)
		setTableData(inputData)
		// Keep the global chevron consistent with the rows of the new data set.
		// Rows were just synced above, so the toggle effect below has nothing left to do : we let it skip its deep clone.
		if (inputConfig.nestedValues && isNewDataSet && toggleAllNestedHandler !== defaultToggleNested) {
			skipToggleAllSyncRef.current = true
			setToggleAllNestedHandler(defaultToggleNested)
		}
		if (!isEmpty(storedChecks)) setStoredChecks([]) // Should reset
	}, [inputData, inputConfig.actions?.edit?.inlineEdit, visibleRows])
	// When data is loaded in DOM
	useEffect(() => {
		// If this props is passed, we trigger the end of loader here instead in reducer
		if (isLoading === false) {
			actionsGlobalLoading.endLoading()
		}
		if (isUndefined(isScrollingContext)) {
			if (!isEqual(storedChecks, [])) {
				setStoredChecks([])
			}
		}
	}, [tableData])

	// When toggling all lines
	useEffect(() => {
		if (inputConfig.nestedValues) {
			// Data set just reloaded : rows are already in the right state, no need for another deep clone / render
			if (skipToggleAllSyncRef.current) {
				skipToggleAllSyncRef.current = false
				return
			}
			//setStateToggleNested(props.toggleAllNestedHandlerValue)
			let leTableData = cloneDeep(tableData)
			map(leTableData, (elem) => {
				elem.toggleNested = toggleAllNestedHandler
			})
			setForceUnsort(true)
			setTableData(leTableData)
		}
	}, [toggleAllNestedHandler])

	// When user clicked reset button of form
	useEffect(() => {
		if (resetCalled && !isEqual(storedValues, watch()) && !isScrolling && isEqual(watch(), {})) {
			setStoredValues(getValues())
		}
	}, [resetCalled])
	useEffect(() => {
		// We need to check is a vertical scroll bar will be rendered
		// In this case, we slighty increased the width

		bodyWrapperRef.current?.offsetHeight > tableOverflowRef.current?.offsetHeight
			? navigator.userAgent.indexOf('Firefox') != -1
				? setScrollBarWidth(tableOverflowRef.current?.offsetWidth - 10)
				: setScrollBarWidth(tableOverflowRef.current?.offsetWidth - 15) // Or the precise size of scrollbar, if we can find it
			: setScrollBarWidth(tableOverflowRef.current?.offsetWidth)
		//))

		setScrollBarRender(
			<ScrollTopWrapper
				width={`${scrollBarWidth}px`}
				onScroll={handleTableScrollTop}
				isScrollable={tableOverflowRef.current?.offsetWidth < tableContentRef.current?.offsetWidth}
				ref={scrollBarTopRef}
			>
				<ScrollTop width={`${tableContentRef?.current?.offsetWidth}px`} />
			</ScrollTopWrapper>
		)
		// before this ref : tableContentRef?.current?.offsetWidth we use widthTable to determine element width
		// it seems that the with lost some pixel occasioning truncate table, with the new ref the problem  seems to be fix
	}, [widthTable, dimensions.height, tableOverflowRef.current?.offsetWidth, scrollBarWidth])
	// When checkall checbox is changing,
	// We clear or store all values (stringified rows)
	useEffect(() => {
		if (isMassEdit) {
			let arr = []
			tableData.forEach((o) => {
				arr.push(JSON.stringify(o))
			})
			setStoredChecks(arr)
			setSingleEdit(true)
		} else {
			setStoredChecks([])
			setSingleEdit(false)
		}
	}, [isMassEdit])
	// When we are using form, used to update stored values.
	// Stored values are used in reset form action for example.
	useEffect(() => {
		const notFilledValues = _.every(watch(), (o) => !o)
		if (!notFilledValues && !isEqual(storedValues, watch()) && !isScrolling && !resetCalled) {
			const b = getValues()
			// Only updating if value isn't equal with default value of row
			let calledChange = false
			forEach(b, (o, k) => {
				// If exists and value is not equal of store => updating ?
				const f = find(inputData, (p) => parseInt(k) === p.itemkioskId)
				if (o !== false && !isUndefined(f)) {
					if (parseInt(f.alertStock) !== parseInt(o.alertStock)) {
						calledChange = true
					}
				}
			})
			// this condition run a infinite loop, update of stock value seems work without this part of code
		}

		if (isExportVisible) {
			setIsScrollingContext()
		}
		//setStoredValues(getValues())
	}, [getValues(), isScrolling])

	// if we remove or add columns on table we nee to test if we pass by the UseColumnsManager hook
	// for use this on TableTitle we have to pass by the store
	useEffect(() => {
		if (!isEqual(cols, [])) {
			setColsTable(cols)
		} else {
			setColsTable(columns)
		}
	}, [columns, cols])

	// To set on store current table height, this value help us to determine
	// paper columns filter height
	useEffect(() => {
		if (!isUndefined(selectTable.current.scrollHeight)) {
			actionsColumns.setTableHeight(selectTable.current.scrollHeight)
		}
	}, [selectTable?.current?.scrollHeight])

	// To enabled validate button on Table Title if we mass edit stock
	// we need to pass a state by the store
	useEffect(() => {
		if (!isEmpty(storedValues) && isEditingTrigger) {
			actionsColumns.setIsValidateEnable()
		}
		if (!isEditingTrigger && !isEmpty(storedValues)) {
			setStoredValues()
		}
	}, [storedValues, isEditingTrigger])

	// When scrolling table, add debounced function to close scroll listening
	useEffect(() => {
		delayedScrollHide()
		return delayedScrollHide.cancel
	}, [isScrolling])

	// Closing export choice menu when clicking outside of it
	useEffect(() => {
		if (!isExportMenuOpen) return
		const handleClickOutside = (e) => {
			if (!isUndefined(exportMenuRef.current) && !exportMenuRef.current.contains(e.target)) {
				setIsExportMenuOpen(false)
			}
		}
		document.addEventListener('mousedown', handleClickOutside)
		return () => document.removeEventListener('mousedown', handleClickOutside)
	}, [isExportMenuOpen])

	// When bottom of vertical scroll is reached
	useEffect(() => {
		if (bottomReached && nextVisibleRowsCount <= visibleRows + padVisibleRows) {
			let currentData = cloneDeep(tableData)
			// We redefine the visible rows, the skeleton ones, or the hidden ones
			let visibleCount = 0
			let skeletonCount = 0
			map(currentData, (elem, k) => {
				// The visible rows
				if (k < visibleRows) {
					elem.rowTableVisible = true
					visibleCount++
				}
				// The skeleton rows
				else if (k >= visibleRows && k < visibleRows + padVisibleRows) {
					elem.rowTableVisible = false
					elem.rowTableSkeleton = true
					skeletonCount++
				}
				// The hidden rows
				else if (k >= visibleRows + padVisibleRows) {
					elem.rowTableVisible = false
					elem.rowTableSkeleton = false
				}
			})
			//const skeletoned = _.countBy(currentData, (o) => o.rowTableSkeleton)
			//const visible = _.countBy(currentData, (o) => o.rowTableVisible)
			// Preparing sum count. It was an attempt to delay showing skeleton rows vs next visible rows
			setNextVisibleRowsCount(skeletonCount + visibleCount)
			setUsingSkeleton(true)
			setForceUnsort(true)
			setTableData(currentData)
		}
	}, [bottomReached])
	// When skeleton rows were asked, we will replace them by visible rows
	useEffect(() => {
		if (usingSkeleton && bottomReached && nextVisibleRowsCount <= visibleRows + padVisibleRows) {
			// Attempting to delay skeleton rows vs real rows, not very sucessfull though

			let currentData = cloneDeep(tableData)
			map(currentData, (elem, k) => {
				if (k >= visibleRows + padVisibleRows) {
					elem.rowTableVisible = false
					elem.rowTableSkeleton = false
				} else {
					elem.rowTableVisible = true
					elem.rowTableSkeleton = false
				}
			})
			// And updating the different states
			setUsingSkeleton(false) // We are not asking skeleton rows anymore
			setForceUnsort(true)
			setTableData(currentData) // Data update
			setBottomReached(false) // Bool update
			setVisibleRows(visibleRows + padVisibleRows > currentData.length ? currentData.length : visibleRows + padVisibleRows) // Updating visible rows count
		}
	}, [usingSkeleton, tableData, nextVisibleRowsCount, bottomReached])

	// Adapting visibleRows and padVisibleRows when we change the pagination
	useEffect(() => {
		if (!isUndefined(currentPaging)) {
			switch (currentPaging.size) {
				case '20':
					setVisibleRows(20)
					setPadVisibleRows(0)
					setNextVisibleRowsCount(20)
					break
				/*case '50':
					setVisibleRows(20)
					setPadVisibleRows(10)
					break */
				case '100':
					setVisibleRows(50)
					setPadVisibleRows(10)
					setNextVisibleRowsCount(60)
					break
				case '250':
					setVisibleRows(100)
					setPadVisibleRows(25)
					setNextVisibleRowsCount(125)
					break
				default:
					setVisibleRows(20)
					setPadVisibleRows(10)
					setNextVisibleRowsCount(30)
					break
			}
		}
	}, [currentPaging])

	useEffect(() => {
		if (!isEqual(storedChecks, [])) {
			actionsColumns.setIsSingleEdit(true)
		} else {
			actionsColumns.setIsSingleEdit(false)
		}
	}, [storedChecks])

	const loc = useLocation()
	//for implantation we have to send data stored to tableTitle component
	// we use the store for that
	useMemo(() => {
		const locationTarget = loc.pathname.split('/')[3]
		if (locationTarget === 'kiosk-implantation' || locationTarget === 'kiosk-edit-implantation') {
			actionsKioskImplantation.setStoredDatas(storedChecks)
		}
	}, [storedChecks])

	// test if export button need to be display
	useMemo(() => {
		if (typeof inputConfig?.export === 'object' && find(user, (e) => e.label === inputConfig?.export?.privilege)) {
			setIsExportVisible(true)
		}
	}, [inputConfig, user])

	///////////////////////////////// RENDER ///////////////////////////////////////
	return (
		<TableWrapper ref={selectTable}>
			<TableActionsWrapper>
				{inputConfig?.pageActions?.length > 0 && (
					<>
						{/*  Might be usefull */}
						{/* <SplitX /> */}
						<ActionWrapperElem>
							{map(inputConfig?.pageActions, (elem) => (
								<elem.component />
							))}
						</ActionWrapperElem>
					</>
				)}
				{isExportVisible && (
					<ExportContainer ref={exportMenuRef}>
						<ExportWrapper>
							<Tooltip translationsKey={'tooltip__admin__global__export__data'} tooltipId={'tableExportData'} position={'left'}>
								<ExportButton src={Export} onClick={handleExportClick} />
							</Tooltip>
						</ExportWrapper>
						{hasExportChoice && isExportMenuOpen && (
							<ExportMenu>
								<ExportMenuItem type="button" onClick={() => handleExportChoice('download')}>
									<ExportMenuItemLabel>{translations['common__text__export__download']}</ExportMenuItemLabel>
									<ExportMenuItemHint warning={isExportVolumeTooHigh}>
										{isExportVolumeTooHigh
											? `${exportRecordsCount.toLocaleString('fr-FR')} ${
													translations['common__text__export__download__tooManyRecords']
											  }`
											: translations['common__text__export__download__hint']}
									</ExportMenuItemHint>
								</ExportMenuItem>
								<ExportMenuItem type="button" onClick={() => handleExportChoice('email')}>
									<ExportMenuItemLabel>{translations['common__text__export__byEmail']}</ExportMenuItemLabel>
									<ExportMenuItemHint>{translations['common__text__export__byEmail__hint']}</ExportMenuItemHint>
								</ExportMenuItem>
							</ExportMenu>
						)}
					</ExportContainer>
				)}
				{
					//  Render of export merchant ticket button
					inputConfig.exportMerchantTicket &&
					find(user, (e) => e.label === inputConfig.export.privilege) &&
					inputConfig.exportMerchantTicket.allowMerchantTicket && (
						<ExportWrapper>
							<Tooltip
								translationsKey={'tooltip__admin__salesOrder__byKiosk_merchantTicket_export'}
								tooltipId={'tableExportDataMerchantTicket'}
								position={'left'}
							>
								<ExportButton src={ExportMerchantTicket} onClick={() => handleExportData('merchant')} />
							</Tooltip>
						</ExportWrapper>
					)
				}
				{inputConfig?.massEdit && !isEditingTrigger && (
					<TooltipHelp content={'tooltipHelp__admin__modal__body__global__table__massEdit'} childrenPos={2}>
						<Tooltip translationsKey={'tooltip__admin__global__massEdit'} position={'left'} tooltipId={'masEditButton'}>
							<ActionWrapperElem>
								<ImgButton
									disabled={inputConfig?.actions?.edit?.inlineEdit?.editId || false || !isSingleEdit}
									img={Edit}
									//disabled={!isSingleEdit}
									/*action={ inputConfig.actions?.edit?.inlineEdit?.editId ? () => { // Old vers. Test on editId might be needed ?
									} : handleMassEdit }*/
									action={isSingleEdit && handleMassEdit}
									color={theme.colors.primary}
									hover={theme.colors.hoverPrimary}
								/>
							</ActionWrapperElem>
						</Tooltip>
					</TooltipHelp>
				)}
				{inputConfig.actions?.followingStepTest && (
					<Tooltip translationsKey={inputConfig?.actions?.followingStepTest?.tooltipTranslationKey} tooltipId={'TableFollowingStepTest'}>
						<ActionWrapperElem>
							<Button
								id={inputConfig.actions.followingStepTest.id}
								type={inputConfig.actions.followingStepTest.type}
								imgLeftMgin={inputConfig.actions.followingStepTest.imgLeftMgin}
								imgMgin={inputConfig.actions.followingStepTest.imgMgin}
								position={inputConfig.actions.followingStepTest.position}
								img={inputConfig.actions.followingStepTest.img}
								margin={inputConfig.actions.followingStepTest.margin}
								bgColor={inputConfig.actions.followingStepTest.bgColor}
								height={inputConfig.actions.followingStepTest.height}
								width={inputConfig.actions.followingStepTest.width}
								text={inputConfig.actions.followingStepTest.text}
								actionHandler={inputConfig.actions.followingStepTest.actionHandler}
								disabled={inputConfig.actions.followingStepTest.disabled}
								padding={inputConfig.actions.followingStepTest.padding}
								noHash
							/>
						</ActionWrapperElem>
					</Tooltip>
				)}

				{inputConfig?.getSelected && inputConfig.getSelected(handleGetSelected)}
				{inputConfig?.openModalSearch && inputConfig.openModalSearch(handleOpenModalSearch)}
			</TableActionsWrapper>
			<TableActionsAndTitle
				shown={
					inputConfig.isInNestedTable ||
					inputConfig.isCampaign ||
					inputConfig.isInModal ||
					(inputConfig.fixedColumnSelection && isEqual(inputConfig.actions, {}))
				}
			>
				<ActionWrapper>
					{inputConfig?.actions?.followingStep?.step && (
						<>
							{inputConfig?.actions?.followingStep?.tooltipTranslationKey ? (
								<Tooltip
									translationsKey={inputConfig?.actions?.followingStep?.tooltipTranslationKey}
									tooltipId={'TableFollowingStep'}
								>
									<ActionWrapperElem>
										<Button
											id={inputConfig.actions.followingStep.id}
											type={inputConfig.actions.followingStep.type}
											imgLeftMgin={inputConfig.actions.followingStep.imgLeftMgin}
											imgMgin={inputConfig.actions.followingStep.imgMgin}
											position={inputConfig.actions.followingStep.position}
											img={inputConfig.actions.followingStep.img}
											margin={inputConfig.actions.followingStep.margin}
											bgColor={inputConfig.actions.followingStep.bgColor}
											height={inputConfig.actions.followingStep.height}
											width={inputConfig.actions.followingStep.width}
											text={inputConfig.actions.followingStep.text}
											actionHandler={inputConfig.actions.followingStep.actionHandler}
											disabled={inputConfig.actions.followingStep.disabled}
											padding={inputConfig.actions.followingStep.padding}
											noHash
										/>
									</ActionWrapperElem>
								</Tooltip>
							) : (
								<ActionWrapperElem>
									<Button
										id={inputConfig.actions.followingStep.id}
										type={inputConfig.actions.followingStep.type}
										imgLeftMgin={inputConfig.actions.followingStep.imgLeftMgin}
										imgMgin={inputConfig.actions.followingStep.imgMgin}
										position={inputConfig.actions.followingStep.position}
										img={inputConfig.actions.followingStep.img}
										margin={inputConfig.actions.followingStep.margin}
										bgColor={inputConfig.actions.followingStep.bgColor}
										height={inputConfig.actions.followingStep.height}
										width={inputConfig.actions.followingStep.width}
										text={inputConfig.actions.followingStep.text}
										actionHandler={inputConfig.actions.followingStep.actionHandler}
										disabled={inputConfig.actions.followingStep.disabled}
										noHash
									/>
								</ActionWrapperElem>
							)}
						</>
					)}
					{inputConfig?.actions?.actionsList?.step && (
						<>
							<SelectInputWrapper blueColor={true} heightAfter={68} alignItems={'center'}>
								<SelectInputCustom
									width={inputConfig?.actions?.actionsList?.width}
									defaultValues=""
									//selectTarget={selectTarget}
									onChange={(e) => handleGetSelected(e)}
									ref={selectAction}
									onClick={(e) => handleResetSelect(e, true)}
									disabled={!isSingleEdit || inputConfig?.actions?.actionsList?.disabled}
								>
									<OptionCustom value="" hidden>
										{translations['common__text__actions']}
									</OptionCustom>
									{map(inputConfig?.actions?.actionsList?.list, (elem, id) => {
										return (
											<OptionCustom
												key={id}
												value={elem.query}
												target={true}
											//onClick={(e) => handleGetSelected(e.target)/*inputConfig.actions.edit.getDataSelected*/}
											>
												{translations[elem.translationKey]}
											</OptionCustom>
										)
									})}
								</SelectInputCustom>
							</SelectInputWrapper>

							{/* <SplitX /> */}
						</>
					)}
					<WrapperFormButton
						ref={selectWrapperFormButton}
						isEditingTrigger={isEditingTrigger}
						positionRight={
							!isUndefined(selectWrapperFormButton.current) && inputConfig.isKioskAddPrices
								? selectWrapperFormButton?.current.offsetWidth
								: null
						}
					>
						{inputConfig?.actions?.saveStep?.step && (
							<>
								<ActionWrapperElem>
									<ImgButton
										id={inputConfig?.actions?.followingStep?.saveStep?.id}
										type={inputConfig?.actions?.saveStep?.type}
										marginRight={inputConfig?.actions?.saveStep?.marginRight}
										img={inputConfig?.actions?.saveStep?.icon}
										hover={inputConfig?.actions?.saveStep?.hover}
										disabled={inputConfig?.actions?.saveStep?.disabled}
									/>
								</ActionWrapperElem>
								{/* <SplitX /> */}
							</>
						)}
						{inputConfig.actions?.edit && editing && (
							<>
								<ActionWrapperElem>
									<Tooltip translationsKey={'tooltip__admin__global__save'} tooltipId={'tableGlobalSave'} position={'left'}>
										<ImgButton
											type={'submit'}
											color={theme.colors.form.validate}
											disabled={isSubmitting || !isDirty || !isEmpty(formState.errors)}
											img={Validation}
											action={handleSubmit((d) => handleOnSubmit(d))}
											hover={theme.colors.hoverValidation}
										/>
									</Tooltip>
								</ActionWrapperElem>

								<ActionWrapperElem>
									<Tooltip translationsKey={'tooltip__admin__global__cancel'} tooltipId={'tableGlobalCancel'} position={'left'}>
										<ImgButton
											color={theme.colors.error}
											img={Cancel}
											action={() => handleCloseForm(inputConfig.actions.edit.cancel)}
											hover={theme.colors.hoverError}
										/>
									</Tooltip>
								</ActionWrapperElem>
								<ActionWrapperElem>
									<Tooltip translationsKey={'tooltip__admin__global__reset'} tooltipId={'tableGlobalReset'} position={'left'}>
										<ImgButton
											color={theme.colors.form.reload}
											disabled={!isDirty}
											img={Reset}
											action={() => handleResetForm()}
											hover={theme.colors.hoverGrey}
										/>
									</Tooltip>
								</ActionWrapperElem>
								{<SplitX />}
							</>
						)}
					</WrapperFormButton>
				</ActionWrapper>
			</TableActionsAndTitle>
			{!isEmpty(columns) && !isUndefined(columns) && (
				<>
					{scrollBarRender}
					<TableReverse
						onSubmit={handleSubmit(handleOnSubmit)}
						ref={tableOverflowRef}
						sizeheight={formHeightHandler()}
						onScroll={handleScroll} // QB 22/10/2021 : I've put back onWheel, but it might cause issues if we work on windowing / infinite scroll
						autosize={
							!isUndefined(inputConfig?.isInNestedTable) || !isUndefined(inputConfig?.isInModal) || !isUndefined(inputConfig?.autoSize)
						}
						tableVirtualizeHeight={tableVirtualizeRef.current?.offsetHeight}
						tableOverflowHeight={tableOverflowRef.current?.offsetHeight}
					>
						<TableVirtualizeWrapper ref={tableVirtualizeRef}>
							<TableContent ref={tableContentRef}>
								<TableHeader
									data={tableData}
									columns={colsTable}
									sortTable={handleSortTableHeader}
									checkboxConf={inputConfig?.actions?.edit}
									editing={isEditingTrigger}
									nestedTheme={!isUndefined(inputConfig?.isInNestedTable)}
									setValue={setValue}
									getValues={getValues}
									hasNestedValues={inputConfig?.nestedValues}
									setToggleAllNestedHandler={() => setToggleAllNestedHandler(!toggleAllNestedHandler)}
									inLineEdit={inputConfig?.actions?.edit?.inlineEdit?.editId || false}
									isCampaignHeader={inputConfig?.isCampaign}
									toggleAllNestedHandler={toggleAllNestedHandler}
									setIsMassEdit={setIsMassEdit}
									isMassEdit={isMassEdit}
									storedChecks={storedChecks}
								/>
								<TableBody
									allData={tableData}
									editingData={selectedData}
									columns={colsTable}
									checkboxConf={inputConfig?.actions?.edit}
									register={register}
									editing={isEditingTrigger}
									getValues={getValues}
									setValue={setValue}
									nestedValues={inputConfig?.nestedValues}
									formError={errors}
									//toggleAllNestedHandlerValue={ toggleAllNestedHandler }
									inLineEdit={inputConfig?.actions?.edit?.inlineEdit || false}
									setInlineEdit={inputConfig?.actions?.edit?.setInlineEdit || false}
									formState={formState}
									setSelectedData={setSelectedData}
									clearErrors={clearErrors}
									isCampaignBody={inputConfig?.isCampaign}
									campaignValues={inputConfig?.campaignValues}
									campaignUpdate={inputConfig?.isUpdateCampaign}
									bodyWrapperRef={bodyWrapperRef}
									setWidthTable={setWidthTable}
									setHeightTable={setHeightTable}
									heightTable={heightTable}
									tableDataSetter={setTableData}
									setForceUnsort={setForceUnsort}
									isScrolling={isScrolling}
									storedValues={storedValues}
									handleCheckValues={handleCheckValues}
									storedChecks={storedChecks}
									setStoredValues={setStoredValues}
								// Unused vars from now, came from previous windowing method
								/*tableOverflowHeight={tableOverflowRef.current?.offsetHeight}
currentScrolled={tableOverflowRef.current?.scrollTop}
availableScroll={
!isUndefined(tableOverflowRef.current?.scrollTopMax)
? tableOverflowRef.current?.scrollTopMax
: tableOverflowRef.current?.scrollHeight - tableOverflowRef.current?.clientHeight
}
scrollBarWidth={scrollBarWidth}
defaultLineHeight={defaultLineHeight}*/
								// noWindowing={/*inputConfig.noWindowing*/ true}
								/>
							</TableContent>
						</TableVirtualizeWrapper>
					</TableReverse>
				</>
			)}
		</TableWrapper>
	)
}

Table.propTypes = {
	inputColumns: PropTypes.array.isRequired,
	inputData: PropTypes.array,
	inputConfig: PropTypes.object.isRequired,
}
Table.defaultPropTypes = {
	inputColumns: [],
	inputData: [],
	inputConfig: {},
}

export default Table
